/**
 * 消息数量格式
 * > 100 99+
 *  */
export const formatPromptMsgNumber = (n: number) => {
  return n > 99 ? '99+' : n;
};

/**
 * 点赞收藏分享评论浏览等数量统一规则显示
 * 1. 0 不展示
 * 2. 1-999 仅展示数值
 * 3. 1000及以上均展示k,仅保留1位小数,不用进位: 1.2k 30.8k 99.9k 10.0k
 * 4. 100000及以上统一展示10w+
 */
export const formatDisplayNumber = (
  number: number,): string => {
  let formatNumber = number;

  // 字符串数字转数字
  if (typeof number === 'string') {
    formatNumber = +formatNumber;
  }

  if ((typeof formatNumber !== 'number') || formatNumber === 0) {
    return '';
  }

  if (formatNumber < 1000) {
    return `${formatNumber}`;
  } else if (formatNumber >= 1000 && formatNumber < 100000) {
    return `${(Math.floor((formatNumber / 1000) * 10) / 10).toFixed(1)}k`;
  } else {
    return '10w+';
  }
};
